$(".onload-text input[type='file'] ").change(function () {
    $(this).parent().find("p").text("Завантажено");

    var a = $(this).parents('.onload-text').siblings("a");
    if (this.files && this.files["0"]) {
        $(this.files).each(function (index) {
            var reader = new FileReader();

            reader.onload = function (e) {
                a.attr("href", e.target.result);
                a.find('img').removeClass("d-none")
                    .attr("src", e.target.result)
                ;
            };

            reader.readAsDataURL(this);
        });
    }
});

$(".onload-photo input[type='file'] ").change(function () {
    var img = $(this).parent().find("img");
    var imgD = $(this).parents('.page-photo-person');

    if (this.files && this.files["0"]) {
        $(this.files).each(function (index) {
            var reader = new FileReader();
            if(this.type === 'application/pdf')
            {
                img.removeClass("d-none").attr("src", "/img/images/pdf-file.png");
                imgD.removeClass("d-none").addClass("d-none").attr("src", "/img/images/pdf-file.png");
                img.siblings("div").removeClass("d-none");
            }
            else {
                reader.onload = function (e) {

                    img.siblings("div")
                        .removeClass("d-flex")
                        .addClass("d-none")
                    ;
                    img.removeClass("d-none")
                        .attr("src", e.target.result)
                    ;

                    imgD.removeClass("d-none")
                        .attr("src", e.target.result)
                    ;
                };

                reader.readAsDataURL(this);
            }
        });
    }
});

$(document).ready(function () {
    $('#navbar-main').on('click', function () {
        $(this).toggleClass('active');
    });
});

